import { useAtom } from 'jotai/index';
import { Toast } from 'primereact/toast';
import { endpointDocumentClauseDELETE } from '~/api/def/endpoints/document/documentClauseEndpoint';
import {
  endpointFundDocumentExtractedFieldDELETE,
  endpointFundDocumentExtractedFieldEDIT,
} from '~/api/def/endpoints/document/documentExtractionEndpoint';
import { toastAtom } from '~/atoms/toastAtom';
import { useDocumentOverviewApi } from '~/components/ui/document/dialogs/documentOverviewDialog/useDocumentOverviewApi';

export const useFieldModifyApi = () => {
  const [toastCurrent] = useAtom<Toast | null>(toastAtom);
  const { fetchDocumentFields } = useDocumentOverviewApi({ documentId: '' });
  const deleteExtractedField = async (fieldId: string, documentId: string) => {
    if (documentId) {
      endpointFundDocumentExtractedFieldDELETE(documentId, fieldId)
        .then((res) => {
          if (res && res.response === 200) {
            fetchDocumentFields(documentId);
            toastCurrent?.show({
              severity: 'success',
              summary: 'Field deleted successfully',
            });
          } else {
            toastCurrent?.show({
              severity: 'error',
              summary: 'Something went wrong',
            });
          }
        })
        .catch(() => {
          toastCurrent?.show({
            severity: 'error',
            summary: 'Something went wrong',
          });
        });
    } else {
      toastCurrent?.show({
        severity: 'error',
        summary: 'Document ID is undefined',
      });
    }
  };
  const deleteExtractedClause = (fieldId: string, documentId: string) => {
    if (documentId) {
      endpointDocumentClauseDELETE(documentId, fieldId)
        .then((res) => {
          if (res && res.response === 200) {
            // setReload((prev) => !prev);
            fetchDocumentFields();
            toastCurrent?.show({
              severity: 'success',
              summary: 'Clause deleted successfully',
            });
          } else {
            toastCurrent?.show({
              severity: 'error',
              summary: 'Something went wrong',
            });
          }
        })
        .catch(() => {
          toastCurrent?.show({
            severity: 'error',
            summary: 'Something went wrong',
          });
        });
    } else {
      toastCurrent?.show({
        severity: 'error',
        summary: 'Document ID is undefined',
      });
    }
  };
  const editExtractedField = async (
    fieldId: string,
    documentId: string,
    updatedValue: string,
    successCallback: () => void,
  ) => {
    if (documentId) {
      endpointFundDocumentExtractedFieldEDIT(documentId, fieldId, {
        updatedValue: updatedValue,
      })
        .then((res) => {
          if (res && res.response === 200) {
            successCallback();
            toastCurrent?.show({
              severity: 'success',
              summary: 'Field updated successfully',
            });
          } else {
            toastCurrent?.show({
              severity: 'error',
              summary: 'Something went wrong',
            });
          }
        })
        .catch(() => {
          toastCurrent?.show({
            severity: 'error',
            summary: 'Something went wrong',
          });
        });
    } else {
      toastCurrent?.show({
        severity: 'error',
        summary: 'Document ID is undefined',
      });
    }
  };
  const handleDeleteField = (
    fieldId: string,
    documentId: string,
    type: string,
  ) => {
    if (type === 'clauses') deleteExtractedClause(fieldId, documentId);
    if (type === 'fields') deleteExtractedField(fieldId, documentId);
  };
  return {
    handleDeleteField,
    editExtractedField,
  } as const;
};
